<script>
export default {
    name: "IconCameraYellowGradient",
};
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
    >
        <!-- Определяем градиент -->
        <defs>
            <linearGradient id="cameraGradient">
                <stop offset="0%" stop-color="#ffcf33" />
                <stop offset="60%" stop-color="#f59e0b" />
                <stop offset="100%" stop-color="#f59e0b" />
            </linearGradient>
        </defs>

        <!-- Применяем градиент к stroke -->
        <path
            class="stroke-[url(#cameraGradient)]"
            fill="none"
            stroke-width="2"
            stroke-linejoin="round"
            d="M4 18V8a1 1 0 0 1 1-1h1.5l1.707-1.707A1 1 0 0 1 8.914 5h6.172a1 1 0 0 1 .707.293L17.5 7H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z"
        />
        <path
            class="stroke-[url(#cameraGradient)]"
            fill="none"
            stroke-width="2"
            stroke-linejoin="round"
            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
    </svg>
</template>

<style scoped>
/* Tailwind JIT позволит использовать stroke-[url(...)] без доп. настроек */
</style>
